import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { api, ErrorApi, sesion } from './api';
import { AvisoError, Boton } from './ui';

export function Entrar() {
  const [email, setEmail] = useState('');
  const [clave, setClave] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [ocupado, setOcupado] = useState(false);
  const navegar = useNavigate();

  async function enviar(e: FormEvent) {
    e.preventDefault();
    setOcupado(true);
    setError(null);
    try {
      const { token } = await api.entrar(email, clave);
      sesion.set(token);
      navegar('/');
    } catch (err) {
      // Mismo mensaje para usuario inexistente y clave mala. Si distinguiéramos, cualquiera
      // podría averiguar qué correos tienen cuenta probando: eso es un oráculo, y con él se
      // arma la lista de a quién atacar.
      setError(err instanceof ErrorApi ? 'El correo o la contraseña no coinciden.' : 'Algo falló.');
    } finally {
      setOcupado(false);
    }
  }

  return (
    <div className="grid min-h-screen place-items-center px-4" style={{ background: 'var(--bg)' }}>
      <form
        onSubmit={enviar}
        className="w-full max-w-[380px] rounded-2xl p-7"
        style={{ background: 'var(--surface)', border: '1px solid var(--border)' }}
      >
        <div className="mb-6 flex items-center gap-2.5">
          <div
            className="grid h-[30px] w-[30px] place-items-center rounded-lg text-[16px] font-extrabold"
            style={{ background: 'var(--accent)', color: 'var(--logo-fg)' }}
          >
            V
          </div>
          <span className="text-[17px] font-bold tracking-[-0.01em]">Valídate</span>
        </div>

        <div className="flex flex-col gap-3">
          <label className="flex flex-col gap-1.5">
            <span className="text-[12.5px] font-medium" style={{ color: 'var(--text-2)' }}>
              Correo
            </span>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoComplete="email"
              placeholder="tu@empresa.com"
              className="rounded-lg px-3 py-2.5 text-[13.5px] outline-none"
              style={{
                background: 'var(--surface-2)',
                border: '1px solid var(--border-2)',
                color: 'var(--text)',
              }}
            />
          </label>

          <label className="flex flex-col gap-1.5">
            <span className="text-[12.5px] font-medium" style={{ color: 'var(--text-2)' }}>
              Contraseña
            </span>
            <input
              type="password"
              value={clave}
              onChange={(e) => setClave(e.target.value)}
              required
              autoComplete="current-password"
              className="rounded-lg px-3 py-2.5 text-[13.5px] outline-none"
              style={{
                background: 'var(--surface-2)',
                border: '1px solid var(--border-2)',
                color: 'var(--text)',
              }}
            />
          </label>

          {error ? <AvisoError mensaje={error} reembolsado={false} /> : null}

          <div className="mt-2">
            <Boton type="submit" variante="primario" disabled={ocupado}>
              {ocupado ? 'Entrando…' : 'Entrar'}
            </Boton>
          </div>
        </div>
      </form>
    </div>
  );
}
